<template>
  <section>
    <v-dialog v-model="dialog">
      <div class="dialog-container">
        <div class="header">
          <h3>Import New File</h3>
          <span
            class="el-icon-close icon"
            @click="changeDialog"></span>
        </div>
        <div class="main">
          <div class="form-item">
            <span>Do you want to overwrite the shiped records?</span>
            <v-radio-group
              v-model="form.is_cover"
              :list="yesNoOptions"/>
          </div>
          <div class="form-item">
            <span>Do you need to send SMS and Notification?</span>
            <v-radio-group
              v-model="form.is_send"
              :list="yesNoOptions"/>
          </div>
          <div class="form-item">
            <span>Upload Excel File</span>
            <file-container
              edit
              :notUpload= true
              :showDownload= false
              :fileData = fileData
              uploadBtnType="success"
              uploadLabel="Upload"
              @delete="handlerDeleteFile"
              @uploadForm="handleUpload"></file-container>
          </div>
        </div>
        <div class="btn">
          <v-button
            @click="changeDialog">Close</v-button>
          <v-button
            type="primary"
            @click="submitForm">Submit</v-button>
        </div>
      </div>
    </v-dialog>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {importExcel} from '@/api/micropolicy'
export default {
  name: 'ImportFile',
  mixins: [MixinOptions],
  data () {
    return {
      dialog: false,
      file: null,
      form:{
        is_cover: 1,
        is_send: 1
      },
      fileData:{}
    }
  },
  methods: {
    changeDialog(){
      this.dialog = !this.dialog
    },

    handleUpload(val){
      this.file = val.params
      this.$set(this.fileData,'client_name',val.file.name)
      this.$set(this.fileData,'url',val.result.url)
    },

    handlerDeleteFile(){
      this.$set(this.fileData,'client_name','')
      this.$set(this.fileData,'url','')
    },

    submitForm(){
      this.network().importExcel()
    },

    network(){
      return {
        importExcel: async() => {
          this.file.append('is_cover',this.form.is_cover)
          this.file.append('is_send',this.form.is_send)
          const {status} = await importExcel(this.file)
          if(status == 200){
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.$emit('uploadSuccess')
            this.handlerDeleteFile()
            this.changeDialog()
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.dialog-container{
  padding: 15px;
  .header{
    height: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    h3{
      padding-bottom: 0;
    }
    .icon{
      font-size: 20px;
      cursor: pointer;
    }
  }
  .btn{
    margin-top: 20px;
    text-align: right;
  }
}
/deep/ .el-radio{
  margin-right: 30px !important;
}
</style>
